export default [
    {
        transID: "101238",
        amount: "864",
        date: "12 jan 2021",
        status:"Dispatched"
    },
    {
        transID: "501243",
        amount: "586",
        date: "22 jun 2021",
        status:"Transit"
    },
    {
        transID: "901268",
        amount: "596",
        date: "22 jan 2021",
        status:"Delivered"
    },
     {
        transID: "101238",
        amount: "864",
        date: "12 jan 2021",
        status:"Dispatched"
    },
    {
        transID: "501243",
        amount: "586",
        date: "22 jun 2021",
        status:"Transit"
    },
    {
        transID: "901268",
        amount: "596",
        date: "22 jan 2021",
        status:"Delivered"
    },
     {
        transID: "101238",
        amount: "864",
        date: "12 jan 2021",
        status:"Dispatched"
    },
    {
        transID: "501243",
        amount: "586",
        date: "22 jun 2021",
        status:"Transit"
    },
    {
        transID: "901268",
        amount: "596",
        date: "22 jan 2021",
        status:"Delivered"
    },
     {
        transID: "101238",
        amount: "864",
        date: "12 jan 2021",
        status:"Dispatched"
    },
    {
        transID: "501243",
        amount: "586",
        date: "22 jun 2021",
        status:"Transit"
    },
    {
        transID: "901268",
        amount: "596",
        date: "22 jan 2021",
        status:"Delivered"
    } ]